// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./imgs/default.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Avatar-module__ui-Avatar--nWt7h {
  display: inline-block;
  position: relative;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 50%;
}

.Avatar-module__ui-Avatar--nWt7h:not(:has(> img)) {
  background-color: #fff4df;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 115% auto;
  box-shadow: inset 0 0 0 1px rgb(139 100 57 / 12%);
}

.Avatar-module__ui-Avatar--nWt7h > img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.Avatar-module__size-medium--k1dw_ {
  width: 34px;
  height: 34px;
}

.Avatar-module__size-small--Heegj {
  width: 28px;
  height: 28px;
}

.Avatar-module__size-x-small--u3E0V {
  width: 18px;
  height: 18px;
}`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Avatar/Avatar.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yDAAyC;EACzC,4BAA4B;EAC5B,+BAA+B;EAC/B,0BAA0B;EAC1B,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".ui-Avatar {\n  display: inline-block;\n  position: relative;\n  flex-shrink: 0;\n  overflow: hidden;\n  border-radius: 50%;\n}\n\n.ui-Avatar:not(:has(> img)) {\n  background-color: #fff4df;\n  background-image: url(./imgs/default.png);\n  background-repeat: no-repeat;\n  background-position: center top;\n  background-size: 115% auto;\n  box-shadow: inset 0 0 0 1px rgb(139 100 57 / 12%);\n}\n\n.ui-Avatar > img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.size-medium {\n  width: 34px;\n  height: 34px;\n}\n\n.size-small {\n  width: 28px;\n  height: 28px;\n}\n\n.size-x-small {\n  width: 18px;\n  height: 18px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-Avatar": `Avatar-module__ui-Avatar--nWt7h`,
	"size-medium": `Avatar-module__size-medium--k1dw_`,
	"size-small": `Avatar-module__size-small--Heegj`,
	"size-x-small": `Avatar-module__size-x-small--u3E0V`
};
export default ___CSS_LOADER_EXPORT___;
